import $ from 'dibs-jquery-shim';
import DC from 'bunsen/helpers/dibsConstants';
import { initialize, runNotificationQueue } from 'dibs-buyer-layout/src/entries/index';

export function init(notifications) {
    initialize({ notifications });
    $.subscribe(DC.pageEventPrefix + ':updated', () => runNotificationQueue());
}

export default { init };



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/nav.es.js